var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 502,
    viewBox: "0 0 256 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9851 378.305C93.3179 379.436 94.3841 380.829 95.8058 381.787C95.1838 384.573 95.7169 387.271 95.8058 389.97C95.9835 392.408 95.9835 394.845 95.9835 397.283C95.8946 406.162 97.4051 414.868 99.0933 423.66C100.248 429.841 102.914 435.413 104.513 441.419C106.379 448.036 108.334 454.652 109.222 461.442C109.756 465.621 109.489 469.799 109.4 473.978",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.598 259.786C88.8751 263.15 89.1417 266.003 88.8751 268.528C88.5197 272.793 88.6974 277.146 88.4309 281.499C87.9866 288.463 89.4971 295.253 91.4519 302.044C93.5843 309.182 96.6942 315.885 99.0932 322.85C101.492 329.814 103.003 336.866 102.647 344.178",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.255 211.158C84.6993 219.864 83.3665 228.482 81.9448 237.101C81.234 241.192 79.5458 244.935 78.6573 249.027C77.8576 252.857 77.1468 256.775 76.6137 260.692C76.2583 262.956 76.3471 265.306 76.0806 267.57",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.283 302.795C112.017 306.712 110.911 309.964 109.845 313.794C108.423 318.756 107.268 323.805 107.534 329.029C107.801 333.556 109.223 337.734 112.421 341.129C115.531 344.437 118.019 343.219 119.263 339.911C120.063 337.734 120.751 334.854 120.928 332.59",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8447 193.225C53.5119 197.403 51.2017 200.972 48.625 204.455C43.7381 211.158 38.6735 217.774 33.6978 224.564C31.9207 227.002 29.8771 229.352 28.5443 232.051C26.7673 235.707 24.9014 239.451 25.9676 243.716",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7123 193.659C51.3795 197.141 49.3359 200.101 47.1146 203.061C42.9385 208.807 38.0516 214.03 34.0533 219.95C31.21 224.302 28.8998 229.091 25.168 233.008C22.6801 235.62 20.5477 238.579 17.2602 240.234C16.6382 240.582 15.9274 241.017 15.1277 240.843",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.528 244.239C123.528 245.98 122.462 247.46 121.751 249.027C119.885 253.032 118.908 257.21 118.108 261.563C117.397 265.568 116.864 269.572 116.064 273.49C115.798 274.708 115.975 276.014 115.887 277.233C115.62 281.673 114.252 285.956 115.318 290.483L115.62 292.525",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.839 90.8482C119.44 89.1071 116.508 89.1071 113.754 88.5848C109.844 87.8013 105.935 87.4531 102.025 86.5825C100.248 86.1472 98.2047 86.1472 96.2499 86.0602C93.3178 85.8861 90.3857 85.0155 87.5424 84.9285C84.9657 84.8414 82.3001 83.9709 79.6345 84.5802",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0906 116.997C80.0227 116.997 80.7897 117.574 83.011 120.011C85.2324 122.362 87.8979 124.451 91.2743 125.06C94.3842 125.583 97.494 126.018 100.693 125.583C105.402 124.886 109.933 123.755 114.554 122.623",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4943 198.274C36.5412 205.674 32.7205 214.205 29.2553 222.911C28.3668 225.087 27.656 227.438 25.8789 229.179",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.998 248.767C114.287 251.901 112.865 254.686 111.977 257.733C110.289 264.001 109.667 270.269 110.289 276.711",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.844 111.306C106.646 112.96 103.714 114.962 100.426 116.529C95.0948 119.228 90.0668 120.504 84.2025 118.589C83.6694 118.415 79.7082 116.129 79.175 116.216",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.904 143.082C126.904 146.216 126.638 149.35 126.371 152.484C126.105 155.966 126.904 159.535 126.726 163.105C126.638 165.02 126.638 167.022 126.104 168.937",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7981 145.922C93.7981 146.183 94.0288 146.651 94.2954 146.912C98.0272 149.698 99.0046 153.963 99.7154 157.968C100.87 163.975 102.114 169.894 106.024 174.857",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.237 66.9951C127.704 67.0822 127.526 67.3433 127.615 67.8657C127.881 70.9126 127.17 73.8724 127.082 76.8323C126.993 79.9663 126.815 83.2744 124.416 85.799",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0093 81.8818C87.8978 82.3171 88.7863 82.3171 89.7637 82.3171C93.9398 82.3171 98.027 82.7524 102.114 83.5359C103.447 83.797 104.957 83.5359 106.379 83.797",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7847 137.684C93.4955 139.773 95.4502 140.643 97.3161 141.166C98.4712 141.514 99.0043 141.862 99.4486 142.907C101.226 146.737 101.759 150.829 102.825 154.833C103.358 156.662 103.802 158.577 104.691 160.231",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9172 162.756C95.6281 164.062 95.8946 165.716 97.494 166.499C97.9382 166.673 97.6716 167.196 97.6716 167.544C97.8493 172.767 99.893 177.294 103.447 181.124",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.104 171.896C125.926 177.99 126.726 184.171 125.927 190.265",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M125.394 64.123C125.749 70.2169 126.016 76.3107 123.439 82.0564",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.263 244.239C113.665 249.288 108.511 254.686 106.112 261.998C105.757 262.956 105.046 264.001 105.668 265.132",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.104 192.354C126.282 196.62 126.371 200.886 126.726 205.064C126.815 205.935 127.615 206.457 127.348 207.328",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.844 41.1396C111.977 42.7937 114.02 44.6218 116.242 46.1888C118.196 47.5817 117.574 49.7581 117.219 51.5862C117.041 52.5438 117.219 53.5885 116.686 54.5461",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.601 32.3477C111.977 36.004 116.775 36.8745 120.773 34.6981C121.751 34.1758 122.373 33.4794 122.906 32.6088",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.977 412.167C112.332 414.082 112.687 416.084 113.043 418C113.487 420.437 114.642 422.352 116.419 424.094C116.952 424.616 117.574 424.964 118.374 424.877",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.177 479.897C110.822 483.118 110.733 486.34 109.045 489.299C108.6 490.083 108.252 490.336 107.807 491.12",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 51.1514C120.684 54.8947 121.306 58.6381 123.083 62.0332",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M113.31 480.681C114.465 483.989 115.175 487.297 113.754 490.692C113.665 490.953 113.576 490.692 113.31 490.692",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.865 36.5264C116.419 38.6157 120.24 40.1827 123.083 43.2296",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.156 480.332C107.534 484.075 107.09 487.906 103.003 489.908",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.395 87.8886C118.285 85.9734 114.909 84.6676 111.177 84.3193",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M123.083 62.8164C123.083 65.5151 123.172 68.1268 121.573 70.5643",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.508 389.446C114.198 390.926 113.665 393.277 113.31 395.714C113.221 396.062 112.529 397.468 112.529 397.949",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6716 159.622C98.1153 161.798 98.4703 163.975 97.6716 166.064",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M126.904 55.3301C126.46 57.5064 124.683 58.9864 124.327 61.1628",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9172 156.053C95.9835 158.49 97.0497 159.274 99.3599 159.187",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6261 149.784C98.8264 149.697 98.0267 149.61 97.3159 149.61",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.526 378.305C162.193 379.436 161.127 380.829 159.705 381.787C160.327 384.573 159.794 387.271 159.705 389.97C159.528 392.408 159.528 394.845 159.528 397.283C159.617 406.162 158.106 414.868 156.418 423.66C155.263 429.841 152.597 435.413 150.998 441.419C149.132 448.036 147.177 454.652 146.289 461.442C145.756 465.621 146.022 469.799 146.111 473.978",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M165.913 259.786C166.636 263.15 166.369 266.003 166.636 268.528C166.991 272.793 166.813 277.146 167.08 281.499C167.524 288.463 166.014 295.253 164.059 302.044C161.926 309.182 158.817 315.885 156.418 322.85C154.019 329.814 152.508 336.866 152.863 344.178",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M171.256 211.158C170.811 219.864 172.144 228.482 173.566 237.101C174.277 241.192 175.965 244.935 176.853 249.027C177.653 252.857 178.364 256.775 178.897 260.692C179.252 262.956 179.164 265.306 179.43 267.57",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M143.228 302.795C143.494 306.712 144.6 309.964 145.666 313.794C147.088 318.756 148.243 323.805 147.977 329.029C147.71 333.556 146.288 337.734 143.09 341.129C139.98 344.437 137.492 343.219 136.248 339.911C135.448 337.734 134.76 334.854 134.583 332.59",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M200.666 193.226C201.999 197.404 204.309 200.973 206.886 204.456C211.773 211.159 216.837 217.775 221.813 224.565C223.59 227.003 225.634 229.353 226.966 232.052C228.743 235.708 230.609 239.452 229.543 243.717",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M202.798 193.659C204.131 197.141 206.175 200.101 208.396 203.061C212.572 208.807 217.459 214.03 221.457 219.95C224.301 224.302 226.611 229.091 230.343 233.008C232.831 235.62 234.963 238.579 238.251 240.234C238.873 240.582 239.583 241.017 240.383 240.843",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M131.983 244.239C131.983 245.98 133.05 247.46 133.76 249.027C135.626 253.032 136.604 257.21 137.403 261.563C138.114 265.568 138.647 269.572 139.447 273.49C139.714 274.708 139.536 276.014 139.625 277.233C139.891 281.673 141.259 285.956 140.193 290.483L139.891 292.525",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M133.671 90.8482C136.07 89.1071 139.002 89.1071 141.757 88.5848C145.666 87.8013 149.576 87.4531 153.485 86.5825C155.262 86.1472 157.306 86.1472 159.261 86.0602C162.193 85.8861 165.125 85.0155 167.968 84.9285C170.545 84.8414 173.211 83.9709 175.876 84.5802",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M178.42 116.997C175.488 116.997 174.721 117.574 172.5 120.011C170.278 122.362 167.613 124.451 164.236 125.06C161.127 125.583 158.017 126.018 154.818 125.583C150.109 124.886 145.577 123.755 140.957 122.623",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M213.017 198.274C218.97 205.674 222.79 214.205 226.256 222.911C227.144 225.087 227.855 227.438 229.632 229.179",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.513 248.767C141.224 251.901 142.645 254.686 143.534 257.733C145.222 264.001 145.844 270.269 145.222 276.711",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M145.666 111.306C148.865 112.96 151.797 114.962 155.085 116.529C160.416 119.228 165.444 120.504 171.308 118.589C171.841 118.415 175.803 116.129 176.336 116.216",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M128.607 143.082C128.607 146.216 128.873 149.35 129.14 152.484C129.406 155.966 128.607 159.535 128.784 163.105C128.873 165.02 128.873 167.022 129.406 168.937",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M161.713 145.922C161.713 146.183 161.482 146.651 161.216 146.912C157.484 149.698 156.506 153.963 155.796 157.968C154.641 163.975 153.397 169.894 149.487 174.857",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M127.274 66.9951C127.807 67.0822 127.985 67.3433 127.896 67.8657C127.629 70.9126 128.34 73.8724 128.429 76.8323C128.518 79.9663 128.696 83.2744 131.095 85.799",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M168.501 81.8818C167.613 82.3171 166.724 82.3171 165.747 82.3171C161.571 82.3171 157.484 82.7524 153.396 83.5359C152.064 83.797 150.553 83.5359 149.131 83.797",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M162.726 137.684C162.015 139.773 160.06 140.643 158.195 141.166C157.04 141.514 156.506 141.862 156.062 142.907C154.285 146.737 153.752 150.829 152.686 154.833C152.153 156.662 151.708 158.577 150.82 160.231",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M160.594 162.757C159.883 164.063 159.616 165.717 158.017 166.5C157.573 166.674 157.839 167.197 157.839 167.545C157.661 172.768 155.618 177.295 152.064 181.125",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 171.896C129.584 177.99 128.784 184.171 129.584 190.265",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.117 64.123C129.762 70.2169 129.495 76.3107 132.072 82.0564",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M136.248 244.239C141.846 249.288 146.999 254.686 149.398 261.998C149.754 262.956 150.464 264.001 149.843 265.132",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 192.354C129.229 196.62 129.14 200.886 128.784 205.064C128.695 205.935 127.896 206.457 128.162 207.328",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.667 41.1396C143.534 42.7937 141.49 44.6218 139.269 46.1888C137.314 47.5817 137.936 49.7581 138.292 51.5862C138.469 52.5438 138.292 53.5885 138.825 54.5461",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M146.91 32.3477C143.534 36.004 138.736 36.8745 134.738 34.6981C133.76 34.1758 133.138 33.4794 132.605 32.6088",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M143.534 412.167C143.179 414.082 142.823 416.084 142.468 418C142.023 420.437 140.868 422.352 139.091 424.094C138.558 424.616 137.936 424.964 137.137 424.877",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.333 479.897C144.689 483.118 144.778 486.34 146.466 489.299C146.91 490.083 147.259 490.336 147.703 491.12",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M135.448 51.1514C134.827 54.8947 134.205 58.6381 132.428 62.0332",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.201 480.681C141.046 483.989 140.336 487.297 141.757 490.692C141.846 490.953 141.935 490.692 142.201 490.692",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M142.646 36.5264C139.092 38.6157 135.271 40.1827 132.428 43.2296",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M147.355 480.332C147.977 484.075 148.421 487.906 152.508 489.908",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M134.116 87.8886C137.226 85.9734 140.602 84.6676 144.334 84.3193",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M132.428 62.8164C132.428 65.5151 132.339 68.1268 133.938 70.5643",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M139.002 389.446C141.313 390.926 141.846 393.277 142.201 395.714C142.29 396.062 142.982 397.468 142.982 397.949",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.839 159.622C157.395 161.798 157.04 163.975 157.839 166.064",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M128.607 55.3301C129.051 57.5064 130.828 58.9864 131.184 61.1628",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M160.594 156.053C159.527 158.49 158.461 159.274 156.151 159.187",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M155.884 149.784C156.684 149.697 157.484 149.61 158.195 149.61",
    stroke: "#7689B1",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0964 129.936C90.5633 131.503 91.5406 132.895 91.8072 134.288C94.1174 144.822 94.8282 155.356 94.7393 166.063C94.7393 167.543 93.8508 168.027 93.8508 170.242C94.7393 173.289 94.1174 176.336 94.2951 179.47C94.5616 182.691 93.4066 185.738 92.3403 188.698C90.741 193.05 88.9639 197.403 86.2095 201.233C85.4098 202.365 85.5875 203.932 84.8767 205.151C82.3888 209.243 80.7895 213.769 79.5456 218.296C78.3016 222.91 77.5908 227.524 77.1465 232.312C76.6134 237.622 77.2354 242.933 76.7023 248.156C76.258 252.857 76.3469 257.471 75.9915 262.172C75.7249 265.567 76.1692 268.875 76.5246 272.183C77.1465 278.277 78.0351 284.284 79.0125 290.378C79.8121 295.601 81.0561 300.737 82.6554 305.873C83.7216 309.356 84.1659 313.012 85.1433 316.581C87.1869 323.546 88.8751 330.597 91.0964 337.474C91.3629 338.432 91.5406 339.39 91.5406 340.434C91.7184 348.53 92.7846 356.626 93.9397 364.636C94.3839 367.595 93.4954 370.381 93.0511 373.167C92.4292 376.823 91.8072 380.567 91.2741 384.223C90.741 387.879 89.6747 391.448 89.0528 395.105C87.8977 401.634 87.2757 408.163 87.6311 414.779C87.8088 417.565 88.342 420.438 90.0302 422.962C91.0964 424.703 90.9187 426.967 91.4518 428.969C92.2515 432.103 94.2062 434.802 94.8282 437.936C95.9833 443.333 98.4711 448.295 99.9816 453.606C101.492 458.916 103.091 464.313 104.069 469.711C104.602 472.409 104.158 475.282 104.158 478.068C104.158 478.851 104.069 479.548 104.691 480.419C105.135 481.115 105.046 482.334 104.424 483.465C102.114 487.731 98.6488 490.778 94.2951 493.041C93.0511 493.738 91.8961 494.26 91.2741 495.74C90.741 496.872 91.0075 497.742 91.6295 498.439C92.3403 499.309 93.4065 499.309 94.3839 498.7",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2095 210.374C86.2095 212.115 86.8314 213.682 87.098 215.423C87.8088 220.559 88.0754 225.783 88.9639 230.919C89.6747 234.924 90.3855 238.928 91.4518 242.758C91.896 244.5 91.7183 245.979 91.3629 247.633C90.7409 250.593 90.4744 253.64 90.0301 256.6C89.2305 262.259 88.3419 267.83 87.72 273.489C87.2757 277.232 87.098 280.976 87.098 284.806C87.098 291.422 86.6537 298.038 87.72 304.654C88.6973 310.574 89.8524 316.494 91.1852 322.414C91.896 325.461 92.6068 328.507 93.0511 331.641C93.4954 335.124 94.6505 338.432 96.0721 341.653C97.7603 345.396 98.7377 349.314 99.715 353.231C100.426 355.93 100.248 358.89 100.692 361.762C101.226 365.419 102.292 368.988 103.003 372.644C103.091 373.167 103.454 375.061 103.721 375.41",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0303 214.553C92.7847 222.91 94.4729 231.528 96.8719 240.06C99.6263 249.81 103.18 259.299 106.912 268.701C109.844 276.013 113.398 283.152 115.264 290.813C116.508 295.775 117.486 300.128 119.085 305.09C119.174 305.351 120.499 309.074 120.499 309.074",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M100.248 381.872C103.536 386.573 105.491 391.796 106.557 397.368C107.09 400.328 107.445 403.375 107.445 406.334C107.356 415.04 107.623 423.745 107.978 432.451C108.245 437.239 108.6 442.114 109.134 446.902C109.844 453.431 111.088 459.873 112.243 466.315C112.51 467.708 112.688 469.101 113.487 470.32",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M112.421 152.656C112.243 157.88 112.421 163.103 112.776 168.326C112.954 171.025 112.688 173.724 112.688 176.509C112.688 178.686 112.776 180.862 113.043 182.951C113.398 185.824 112.776 188.697 112.599 191.483C112.243 196.01 112.066 200.536 112.688 205.063C112.954 207.066 113.043 209.068 113.043 211.157C113.31 217.425 114.998 223.258 117.041 229.09C117.752 231.093 118.463 233.095 119.529 235.01C119.885 235.707 120.329 236.403 120.773 237.099C121.306 237.883 121.928 238.405 122.728 238.318C123.616 238.231 123.972 237.274 124.238 236.49C124.86 234.575 125.482 232.747 126.104 230.832",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M120.063 345.135C120.685 348.617 120.063 352.012 119.618 355.407C118.463 363.677 117.042 371.948 116.242 380.305C115.798 384.745 117.042 389.097 117.486 393.45C118.286 401.198 119.441 408.859 119.352 416.607C119.352 420.785 118.552 424.877 117.841 428.882C117.13 433.06 117.042 437.239 116.686 441.417C116.153 446.989 115.531 452.648 115.442 458.219C115.442 462.137 116.064 466.054 117.486 469.797C117.841 470.842 118.154 472.386 118.598 473.517C117.177 475.346 115.531 476.152 113.399 477.371C114.909 479.025 117.042 479.025 118.73 479.809",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7437 244.167C93.343 247.301 94.9612 253.024 95.4943 256.419C96.5605 262.687 99.2261 268.52 100.914 274.614C102.869 281.752 106.068 288.456 108.911 295.246C111.932 302.297 115.486 309.175 117.796 316.574C118.596 319.012 119.129 321.624 119.751 324.061C119.84 324.496 120.256 326.636 120.621 327.425",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M115.176 383.352C113.843 386.311 113.31 389.532 113.043 392.753C112.51 398.76 112.332 404.854 112.066 410.948C111.888 415.91 111.533 420.872 112.155 425.747C112.243 426.27 112.155 426.879 112.155 427.401C111.888 432.189 112.421 436.977 112.688 441.852C112.865 446.902 113.932 451.864 114.287 456.913C114.463 459.409 115.539 462.831 115.717 463.005",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M112.559 52.2402C112.825 57.3765 113.487 63.5992 114.109 68.7354C114.287 70.0413 113.931 70.7377 112.954 71.4341C110.111 73.8717 106.557 74.7422 103.18 76.048C97.1383 78.3985 91.0075 80.4878 84.7878 82.2289C79.5455 83.7959 76.3469 87.2781 73.1482 91.3697C69.4164 96.2448 67.5505 101.816 66.6619 107.562C65.8623 112.437 65.2403 117.573 66.4842 122.535",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M127.171 255.729C125.216 257.732 125.038 260.343 124.86 262.868C124.505 269.223 124.061 275.578 123.35 281.846C122.817 286.721 121.839 291.596 121.484 296.471C121.306 298.735 121.129 301.085 120.862 303.348C120.151 309.355 121.306 315.362 120.862 321.282C120.418 326.853 121.129 332.425 120.951 337.996C120.862 339.999 120.773 342.088 120.24 344.003C119.974 345.135 119.174 346.092 118.552 347.137C117.308 349.488 115.62 351.577 114.287 353.84C112.066 357.845 110.111 361.849 109.667 366.55C109.4 369.771 109.134 372.992 109.667 376.213C109.844 376.997 110.2 377.519 110.644 378.216C113.221 377.606 113.221 375.343 113.932 373.689C115.442 370.381 115.709 366.812 116.153 363.242C116.597 360.108 116.775 356.974 117.308 353.84C117.486 352.796 117.575 351.577 117.13 350.532",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5715 86.4512C90.7945 88.8887 90.5633 90.7608 90.0302 93.6336C88.8751 99.4663 86.2984 104.603 82.3 109.042C80.4341 111.132 78.1239 112.786 76.0803 114.614C72.8816 117.4 69.2387 119.837 66.3954 123.058C65.9511 123.581 65.6846 124.277 65.3292 124.886C60.9754 132.199 58.7541 140.208 57.1548 148.478C56.4439 151.873 55.9108 155.356 54.7557 158.664C54.0449 160.753 52.6233 162.581 51.2016 164.322C46.4036 170.416 41.8721 176.771 38.318 183.648C36.0967 188.088 34.8528 193.05 33.3423 197.838C31.743 202.713 29.6993 207.327 27.1226 211.854C25.701 214.553 24.3682 217.339 23.6574 220.647C23.302 223.694 21.9692 226.044 20.5475 228.569C19.3036 230.745 17.6154 232.312 15.3941 233.357C11.6623 235.011 9.17443 237.709 7.66393 241.54C6.42 244.761 4.64295 247.808 2.42164 250.507C1.88852 251.116 1.35541 251.812 1 252.683C2.15508 253.902 3.13246 253.902 4.5541 252.857C6.42 251.377 7.66393 249.462 9.44098 247.982",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6538 130.979C85.0544 134.723 84.1659 138.727 82.4777 142.471C80.3452 147.172 78.3905 151.873 75.5472 156.225C74.0367 158.576 73.237 161.188 71.8154 163.538C69.9495 166.585 68.1724 169.806 67.5505 173.375C66.662 178.686 62.7524 182.603 61.0642 187.565C59.5538 192.005 57.4213 196.184 55.4665 200.449C53.2452 205.237 50.402 209.764 47.2033 214.03C42.8495 219.863 38.7623 225.782 34.6751 231.876C33.0757 234.227 32.0983 236.838 33.0757 240.059C34.2308 243.89 32.8092 247.807 31.5652 251.463C29.5216 257.296 27.3892 263.129 25.701 269.049C25.3456 270.267 24.6347 271.399 23.7462 272.357C23.2131 273.053 22.5911 273.575 21.5249 272.879C22.8577 268.352 24.0128 263.651 25.8787 259.211",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5279 123.406C65.1516 130.284 62.486 137.422 60.1758 144.735C58.4876 150.045 57.4214 155.442 57.4214 161.014C57.4214 162.494 57.7768 163.974 58.7542 165.193C59.3761 165.976 60.1758 166.15 61.0643 165.454C62.9302 164.061 64.5296 162.407 65.8624 160.579C66.662 159.447 67.6394 158.489 68.7056 157.706",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M121.395 91.2832C117.041 92.589 113.398 95.2877 109.667 97.7253C105.135 100.598 101.403 104.428 97.3161 107.824C92.3404 112.002 86.7427 114.788 80.2565 115.92C78.746 116.181 77.4132 116.964 75.9916 117.4C75.1919 117.574 74.3922 117.835 73.6814 117.4",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2095 206.369C88.1642 210.374 91.1852 213.769 93.9396 217.164C98.56 222.997 104.247 227.785 110.288 232.312C114.109 235.184 118.108 237.97 122.284 240.408C124.238 241.539 126.282 242.323 128.681 242.062",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M127.642 1C119.023 1.17411 110.822 4.1408 106.468 11.8887C104.247 15.8062 103.891 20.0718 104.78 24.4246C105.046 25.6434 105.313 26.7751 104.957 27.9938",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M87.009 130.979C88.253 132.024 87.8087 133.591 87.9864 134.723C88.5195 140.468 90.1189 145.953 90.9185 151.611C91.6294 156.748 92.3402 161.797 93.4953 166.846C93.5841 167.107 93.7118 170.051 93.8895 170.399",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M78.124 117.398C80.2564 118.356 81.6781 120.01 83.2774 121.577C83.9882 122.274 83.8994 122.796 83.7217 123.666C81.5003 133.591 78.3017 143.167 72.4374 151.698C71.5489 152.917 70.9269 154.223 70.0384 155.441C68.7056 157.444 69.061 159.794 68.3502 161.971C67.284 165.54 65.7735 168.848 62.3082 170.937C58.9318 173.026 55.822 175.464 52.7122 177.902C51.3794 178.946 51.2905 180.861 50.7574 182.428C47.381 192.092 47.381 192.092 39.9174 201.232C36.0079 206.02 31.9207 210.721 28.4554 215.857C27.3892 217.512 26.5895 219.253 25.4344 220.907C25.079 221.342 24.1905 222.387 23.2131 223.344",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M108.6 44.4474C106.024 44.5344 104.78 42.7063 103.98 40.8781C102.736 37.8312 101.759 34.6972 100.959 31.4762C100.604 29.8222 100.604 27.907 102.558 26.8623C105.224 27.5587 105.935 29.474 106.024 31.9115C106.201 34.9584 106.912 38.0053 108.067 40.8781C108.956 42.9675 108.867 45.405 109.755 47.5814C110.822 49.9318 112.066 52.1082 114.02 53.8493C116.419 56.0257 119.529 58.0279 118.996 61.9454C121.395 70.1286 122.728 78.4858 124.594 86.7561C124.949 88.4972 125.571 90.2383 126.637 91.8052",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6732 392.144C93.4955 395.103 92.5181 397.976 92.0739 400.936C91.4519 405.463 90.9188 409.99 90.9188 414.517C90.9188 417.215 90.4563 420.534 90.4563 423.658",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61886 247.546C10.3297 250.593 9.44116 253.64 9.3523 256.774C9.08575 263.564 8.37493 270.441 7.93066 277.232C7.93066 277.841 7.93066 278.712 8.99689 278.712C9.97427 278.712 10.7739 278.624 10.9516 277.493C11.6625 272.879 13.0841 268.439 14.1503 263.912C14.5057 262.345 14.8612 260.865 15.2166 259.298",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M113.487 75.7876C111.088 78.3993 107.889 80.1404 105.224 82.4038C106.734 84.4931 108.334 85.0155 110.733 84.319C112.332 83.8837 113.309 82.5779 113.487 80.5757C113.754 77.5287 114.122 74.347 114.122 70.2021",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M114.731 70.1289C116.153 73.9593 117.486 77.7897 118.996 81.6201C120.329 84.8412 121.129 88.2363 122.994 91.2832",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.327 134.549C119.796 134.027 115.353 135.158 110.91 135.855C107.356 136.464 104.158 135.768 100.87 134.723C95.7166 133.069 91.2739 130.022 87.2756 126.54C86.1205 125.495 85.4097 124.015 83.988 123.058",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M100.248 353.927C102.558 356.887 103.447 360.369 104.069 363.938C104.336 365.505 104.158 367.159 104.336 368.726C104.602 370.99 103.802 373.166 103.714 375.429",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M104.513 201.407C104.246 202.452 103.802 203.497 103.18 204.28C101.048 207.153 98.1156 207.762 94.4726 205.76C91.9848 204.367 89.3192 203.148 87.009 201.407",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 488.254C115.709 490.778 111.088 491.91 106.024 491.214C104.069 490.953 102.47 490.256 101.137 488.863",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1032 260.518C19.7478 263.564 18.5927 266.35 17.793 269.31C16.9933 272.183 16.0159 274.969 15.4828 277.841C15.2163 279.408 14.2389 280.366 12.9061 280.714C11.3068 281.15 11.3068 279.408 10.5959 278.712",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4033 173.464C62.8718 178.252 56.2663 182.43 51.8236 187.392C50.8463 188.436 49.78 189.568 48.2695 189.916",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4003 159.97C55.2888 161.188 54.4892 162.32 54.4003 163.539C54.0449 168.066 53.1564 172.506 52.2679 176.945C52.179 177.207 52.3567 177.468 52.4456 177.816",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5391 132.809C95.8056 134.463 97.0496 135.681 97.9381 136.987C101.048 141.601 104.602 145.867 109.4 148.914",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M119.884 485.728C117.663 485.902 116.863 483.987 115.886 482.768C113.309 479.46 109.222 478.503 105.579 481.985C104.76 482.768 105.313 481.985 105.135 481.985",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M118.818 473.802C120.062 475.369 119.529 477.197 119.351 478.764C119.174 480.505 119.263 482.159 119.707 483.813C120.773 488.079 120.506 492.432 120.506 496.784C120.506 499.222 119.174 500.092 116.952 499.483",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M116.864 468.579C115.353 468.666 114.287 469.798 113.754 470.755C112.243 473.454 109.844 475.108 107.712 477.198C106.823 478.068 106.024 479.113 105.135 480.07",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M110.733 28.7764C114.731 31.388 118.729 31.1268 122.639 28.7764",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M124.594 32.3467C124.594 34.7842 123.794 36.9606 123.083 39.224C122.639 40.7039 122.55 42.0968 124.327 42.7933",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M103.891 135.941C106.024 139.598 108.778 142.558 112.599 144.473",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3474 273.489C20.2811 275.317 19.748 277.407 18.2375 278.974C17.1713 280.105 16.2828 280.018 15.2166 279.322",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M118.476 58.4883C119.518 59.8098 121.129 61.1623 122.017 62.0328C123.439 63.2516 125.656 64.3151 127.611 64.3151",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M127.792 47.8417C125.304 47.1453 123.172 48.1899 121.128 49.4087C122.195 53.065 125.216 53.3262 128.237 53.6744",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M113.043 494.694C112.599 494.956 112.154 495.217 111.799 495.565C110.644 496.522 109.933 497.654 110.377 499.134C110.733 500.179 113.31 501.136 114.553 500.788C116.242 500.44 117.397 499.395 117.752 497.654C117.93 496.871 117.93 496.087 118.019 495.391",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0823 232.921C19.3924 233.269 21.7026 233.356 23.9239 233.966",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M101.314 492.867C100.781 493.738 100.248 494.608 99.6262 495.392C98.56 496.611 98.2046 498.003 98.8266 499.396C99.2708 500.354 101.581 500.267 103.358 499.396C102.47 498.003 103.713 496.872 104.158 495.74C104.424 494.956 105.224 494.347 105.135 493.389",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9378 492.432C96.6939 493.215 95.8942 494.434 95.1834 495.566C94.4726 496.61 94.0283 498.09 94.828 499.048C95.7165 500.092 97.227 500.092 98.5598 499.309",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M109.844 498.438C109.045 498.351 108.6 498.874 108.156 499.222C106.379 500.702 105.491 500.702 103.447 499.222",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M122.017 50.5405C123.972 50.2793 125.838 51.1499 127.792 50.9758",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M120.062 26.5142C118.818 24.599 116.775 25.1213 114.909 25.0342",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6799 225.782C24.1904 227.175 24.9012 229.264 26.9449 230.135",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1226 235.01C28.6331 235.793 30.3212 236.229 32.0094 236.054",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7393 168.152C95.3612 169.632 95.3612 171.199 95.8055 172.766",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2554 231.268C30.677 232.225 32.3652 232.138 33.9646 232.486",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0091 126.801C86.476 128.02 87.0979 129.325 86.8314 130.544",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M124.594 41.3135C125.482 42.2711 126.548 42.7934 127.792 43.2287",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M164.414 129.936C164.947 131.503 163.97 132.895 163.704 134.288C161.393 144.822 160.683 155.356 160.771 166.063C160.771 167.543 161.66 168.027 161.66 170.242C160.771 173.289 161.393 176.336 161.216 179.47C160.949 182.691 162.104 185.738 163.17 188.698C164.77 193.05 166.547 197.403 169.301 201.233C170.101 202.365 169.923 203.932 170.634 205.151C173.122 209.243 174.721 213.769 175.965 218.296C177.209 222.91 177.92 227.524 178.364 232.312C178.897 237.622 178.275 242.933 178.808 248.156C179.253 252.857 179.164 257.471 179.519 262.172C179.786 265.567 179.342 268.875 178.986 272.183C178.364 278.277 177.476 284.284 176.498 290.378C175.699 295.601 174.455 300.737 172.855 305.873C171.789 309.356 171.345 313.012 170.367 316.581C168.324 323.546 166.636 330.597 164.414 337.474C164.148 338.432 163.97 339.39 163.97 340.434C163.792 348.53 162.726 356.626 161.571 364.636C161.127 367.595 162.015 370.381 162.46 373.167C163.082 376.823 163.704 380.567 164.237 384.223C164.77 387.879 165.836 391.448 166.458 395.105C167.613 401.634 168.235 408.163 167.88 414.779C167.702 417.565 167.169 420.438 165.481 422.962C164.414 424.703 164.592 426.967 164.059 428.969C163.259 432.103 161.305 434.802 160.683 437.936C159.527 443.333 157.04 448.295 155.529 453.606C154.019 458.916 152.419 464.313 151.442 469.711C150.909 472.409 151.353 475.282 151.353 478.068C151.353 478.851 151.442 479.548 150.82 480.419C150.376 481.115 150.465 482.334 151.086 483.465C153.397 487.731 156.862 490.778 161.216 493.041C162.46 493.738 163.615 494.26 164.237 495.74C164.77 496.872 164.503 497.742 163.881 498.439C163.17 499.309 162.104 499.309 161.127 498.7",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M169.302 210.374C169.302 212.115 168.68 213.682 168.413 215.423C167.702 220.559 167.436 225.783 166.547 230.919C165.836 234.924 165.125 238.928 164.059 242.758C163.615 244.5 163.793 245.979 164.148 247.633C164.77 250.593 165.037 253.64 165.481 256.6C166.281 262.259 167.169 267.83 167.791 273.489C168.235 277.232 168.413 280.976 168.413 284.806C168.413 291.422 168.857 298.038 167.791 304.654C166.814 310.574 165.659 316.494 164.326 322.414C163.615 325.461 162.904 328.507 162.46 331.641C162.016 335.124 160.861 338.432 159.439 341.653C157.751 345.396 156.773 349.314 155.796 353.231C155.085 355.93 155.263 358.89 154.819 361.762C154.285 365.419 153.219 368.988 152.508 372.644C152.42 373.167 152.057 375.061 151.79 375.41",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M165.481 214.553C162.726 222.91 161.038 231.528 158.639 240.06C155.885 249.81 152.331 259.299 148.599 268.701C145.667 276.013 142.113 283.152 140.247 290.813C139.003 295.775 138.025 300.128 136.426 305.09C136.337 305.351 135.012 309.074 135.012 309.074",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M155.263 381.872C151.975 386.573 150.02 391.796 148.954 397.368C148.421 400.328 148.066 403.375 148.066 406.334C148.154 415.04 147.888 423.745 147.533 432.451C147.266 437.239 146.911 442.114 146.377 446.902C145.667 453.431 144.423 459.873 143.268 466.315C143.001 467.708 142.823 469.101 142.024 470.32",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M143.09 152.656C143.267 157.88 143.09 163.103 142.734 168.326C142.557 171.025 142.823 173.724 142.823 176.509C142.823 178.686 142.734 180.862 142.468 182.951C142.112 185.824 142.734 188.697 142.912 191.483C143.267 196.01 143.445 200.536 142.823 205.063C142.557 207.066 142.468 209.068 142.468 211.157C142.201 217.425 140.513 223.258 138.469 229.09C137.759 231.093 137.048 233.095 135.982 235.01C135.626 235.707 135.182 236.403 134.738 237.099C134.204 237.883 133.583 238.405 132.783 238.318C131.894 238.231 131.539 237.274 131.272 236.49C130.65 234.575 130.028 232.747 129.406 230.832",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M135.449 345.135C134.827 348.617 135.449 352.012 135.893 355.407C137.048 363.677 138.47 371.948 139.27 380.305C139.714 384.745 138.47 389.097 138.026 393.45C137.226 401.198 136.071 408.859 136.16 416.607C136.16 420.785 136.959 424.877 137.67 428.882C138.381 433.06 138.47 437.239 138.825 441.417C139.358 446.989 139.98 452.648 140.069 458.219C140.069 462.137 139.447 466.054 138.026 469.797C137.67 470.842 137.357 472.386 136.913 473.517C138.335 475.346 139.98 476.152 142.113 477.371C140.602 479.025 138.47 479.025 136.782 479.809",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M163.767 244.167C162.168 247.301 160.55 253.024 160.016 256.419C158.95 262.687 156.285 268.52 154.596 274.614C152.642 281.752 149.443 288.456 146.6 295.246C143.579 302.297 140.025 309.175 137.714 316.574C136.915 319.012 136.382 321.624 135.76 324.061C135.671 324.496 135.254 326.636 134.89 327.425",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M140.335 383.352C141.668 386.311 142.201 389.532 142.468 392.753C143.001 398.76 143.179 404.854 143.445 410.948C143.623 415.91 143.978 420.872 143.356 425.747C143.268 426.27 143.356 426.879 143.356 427.401C143.623 432.189 143.09 436.977 142.823 441.852C142.646 446.902 141.579 451.864 141.224 456.913C141.048 459.409 139.972 462.831 139.794 463.005",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M142.952 52.2393C142.685 57.3755 142.024 63.5982 141.402 68.7345C141.224 70.0403 141.579 70.7367 142.557 71.4332C145.4 73.8707 148.954 74.7412 152.33 76.0471C158.372 78.3975 164.503 80.4869 170.723 82.228C175.965 83.795 179.164 87.2771 182.363 91.3687C186.094 96.2438 187.96 101.815 188.849 107.561C189.648 112.436 190.27 117.572 189.027 122.534",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M127.611 255.7C129.566 257.702 130.473 260.343 130.651 262.868C131.006 269.223 131.45 275.578 132.161 281.846C132.694 286.721 133.672 291.596 134.027 296.471C134.205 298.734 134.382 301.085 134.649 303.348C135.36 309.355 134.205 315.362 134.649 321.282C135.093 326.853 134.382 332.425 134.56 337.996C134.649 339.998 134.738 342.088 135.271 344.003C135.537 345.135 136.337 346.092 136.959 347.137C138.203 349.487 139.891 351.577 141.224 353.84C143.445 357.845 145.4 361.849 145.844 366.55C146.111 369.771 146.377 372.992 145.844 376.213C145.667 376.997 145.311 377.519 144.867 378.215C142.29 377.606 142.29 375.343 141.579 373.689C140.069 370.381 139.802 366.811 139.358 363.242C138.914 360.108 138.736 356.974 138.203 353.84C138.025 352.795 137.936 351.577 138.381 350.532",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M162.939 86.4512C164.716 88.8887 164.947 90.7608 165.481 93.6336C166.636 99.4663 169.212 104.603 173.211 109.042C175.077 111.132 177.387 112.786 179.43 114.614C182.629 117.4 186.272 119.837 189.115 123.058C189.56 123.581 189.826 124.277 190.182 124.886C194.535 132.199 196.757 140.208 198.356 148.478C199.067 151.873 199.6 155.356 200.755 158.664C201.466 160.753 202.887 162.581 204.309 164.322C209.107 170.416 213.639 176.771 217.193 183.648C219.414 188.088 220.658 193.05 222.168 197.838C223.768 202.713 225.811 207.327 228.388 211.854C229.81 214.553 231.143 217.339 231.853 220.647C232.209 223.694 233.542 226.044 234.963 228.569C236.207 230.745 237.895 232.312 240.117 233.357C243.848 235.011 246.336 237.709 247.847 241.54C249.091 244.761 250.868 247.808 253.089 250.507C253.622 251.116 254.155 251.812 254.511 252.683C253.356 253.902 252.378 253.902 250.957 252.857C249.091 251.377 247.847 249.462 246.07 247.982",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M168.857 130.979C170.456 134.723 171.345 138.727 173.033 142.471C175.166 147.172 177.12 151.873 179.964 156.225C181.474 158.576 182.274 161.188 183.695 163.538C185.561 166.585 187.338 169.806 187.96 173.375C188.849 178.686 192.758 182.603 194.446 187.565C195.957 192.005 198.089 196.184 200.044 200.449C202.266 205.237 205.109 209.764 208.307 214.03C212.661 219.863 216.748 225.782 220.836 231.876C222.435 234.227 223.412 236.838 222.435 240.059C221.28 243.89 222.702 247.807 223.946 251.463C225.989 257.296 228.122 263.129 229.81 269.049C230.165 270.267 230.876 271.399 231.765 272.357C232.298 273.053 232.92 273.575 233.986 272.879C232.653 268.352 231.498 263.651 229.632 259.211",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M186.983 123.406C190.359 130.284 193.025 137.422 195.335 144.735C197.023 150.045 198.089 155.442 198.089 161.014C198.089 162.494 197.734 163.974 196.757 165.193C196.135 165.976 195.335 166.15 194.446 165.454C192.581 164.061 190.981 162.407 189.648 160.579C188.849 159.447 187.871 158.489 186.805 157.706",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M134.116 91.2822C138.47 92.588 142.113 95.2868 145.844 97.7243C150.376 100.597 154.108 104.428 158.195 107.823C163.171 112.001 168.768 114.787 175.255 115.919C176.765 116.18 178.098 116.963 179.519 117.399C180.319 117.573 181.119 117.834 181.83 117.399",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M169.302 206.369C167.347 210.374 164.326 213.769 161.571 217.164C156.951 222.997 151.264 227.785 145.223 232.312C141.402 235.184 137.403 237.97 133.227 240.408C131.273 241.539 129.229 242.323 126.83 242.062",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.04 1C136.659 1.17411 144.689 4.14055 149.043 11.8884C151.264 15.8059 151.62 20.0716 150.731 24.4243C150.465 25.6431 150.198 26.7748 150.554 27.9936",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 130.979C167.258 132.024 167.702 133.591 167.524 134.723C166.991 140.468 165.392 145.953 164.592 151.611C163.881 156.748 163.171 161.797 162.015 166.846C161.927 167.107 161.799 170.051 161.621 170.399",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M177.387 117.398C175.255 118.356 173.833 120.01 172.234 121.577C171.523 122.274 171.612 122.796 171.789 123.666C174.011 133.591 177.209 143.167 183.074 151.698C183.962 152.917 184.584 154.223 185.473 155.441C186.805 157.444 186.45 159.794 187.161 161.971C188.227 165.54 189.738 168.848 193.203 170.937C196.579 173.026 199.689 175.464 202.799 177.902C204.132 178.946 204.22 180.861 204.754 182.428C208.13 192.092 208.13 192.092 215.594 201.232C219.503 206.02 223.59 210.721 227.056 215.857C228.122 217.512 228.921 219.253 230.077 220.907C230.432 221.342 231.32 222.387 232.298 223.344",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M146.91 44.4474C149.487 44.5344 150.731 42.7063 151.531 40.8781C152.775 37.8312 153.752 34.6972 154.552 31.4762C154.907 29.8222 154.907 27.907 152.952 26.8623C150.287 27.5587 149.576 29.474 149.487 31.9115C149.309 34.9584 148.599 38.0053 147.443 40.8781C146.555 42.9675 146.644 45.405 145.755 47.5814C144.689 49.9318 143.445 52.1082 141.49 53.8493C139.091 56.0257 135.982 58.0279 136.515 61.9454C134.116 70.1286 132.783 78.4858 130.917 86.7561C130.562 88.4972 129.94 90.2383 128.873 91.8052",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M161.838 392.144C162.015 395.103 162.993 397.976 163.437 400.936C164.059 405.463 164.592 409.99 164.592 414.517C164.592 417.215 165.054 420.534 165.054 423.658",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M245.892 247.546C245.181 250.593 246.07 253.64 246.159 256.774C246.425 263.564 247.136 270.441 247.58 277.232C247.58 277.841 247.58 278.712 246.514 278.712C245.537 278.712 244.737 278.624 244.559 277.493C243.849 272.879 242.427 268.439 241.361 263.912C241.005 262.345 240.65 260.865 240.294 259.298",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M142.024 75.7876C144.423 78.3993 147.621 80.1404 150.287 82.4038C148.776 84.4931 147.177 85.0155 144.778 84.319C143.179 83.8837 142.201 82.5779 142.024 80.5757C141.757 77.5287 141.388 74.347 141.388 70.2021",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M140.78 70.1289C139.358 73.9593 138.025 77.7897 136.515 81.6201C135.182 84.8412 134.382 88.2363 132.517 91.2832",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.184 134.548C135.715 134.026 140.158 135.157 144.6 135.854C148.155 136.463 151.353 135.767 154.641 134.722C159.794 133.068 164.237 130.021 168.235 126.539C169.39 125.494 170.101 124.014 171.523 123.057",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M155.263 353.927C152.953 356.887 152.064 360.369 151.442 363.938C151.175 365.505 151.353 367.159 151.175 368.726C150.909 370.99 151.709 373.166 151.797 375.429",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M150.998 201.407C151.264 202.452 151.709 203.497 152.331 204.28C154.463 207.153 157.395 207.762 161.038 205.76C163.526 204.367 166.192 203.148 168.502 201.407",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M135.449 488.254C139.802 490.778 144.423 491.91 149.487 491.214C151.442 490.953 153.041 490.256 154.374 488.863",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M235.408 260.518C235.763 263.564 236.918 266.35 237.718 269.31C238.517 272.183 239.495 274.969 240.028 277.841C240.294 279.408 241.272 280.366 242.605 280.714C244.204 281.15 244.204 279.408 244.915 278.712",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M188.108 173.464C192.639 178.252 199.245 182.43 203.687 187.392C204.665 188.436 205.731 189.568 207.241 189.916",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M201.111 159.97C200.222 161.188 201.022 162.32 201.111 163.539C201.466 168.066 202.355 172.506 203.243 176.945C203.332 177.207 203.154 177.468 203.065 177.816",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M159.972 132.808C159.705 134.462 158.461 135.68 157.573 136.986C154.463 141.6 150.909 145.866 146.111 148.913",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M135.626 485.729C137.848 485.903 138.647 483.988 139.625 482.769C142.201 479.461 146.289 478.504 149.932 481.986C150.751 482.769 150.198 481.986 150.376 481.986",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M136.693 473.802C135.449 475.369 135.982 477.197 136.16 478.764C136.337 480.505 136.248 482.159 135.804 483.813C134.738 488.079 135.004 492.432 135.004 496.784C135.004 499.222 136.337 500.092 138.559 499.483",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M138.647 468.579C140.158 468.666 141.224 469.798 141.757 470.755C143.268 473.454 145.667 475.108 147.799 477.198C148.688 478.068 149.487 479.113 150.376 480.07",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M144.778 28.7764C140.78 31.388 136.781 31.1268 132.872 28.7764",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M130.917 32.3467C130.917 34.7842 131.717 36.9606 132.428 39.224C132.872 40.7039 132.961 42.0968 131.184 42.7933",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M151.62 135.941C149.487 139.598 146.733 142.558 142.912 144.473",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M234.164 273.489C235.23 275.317 235.763 277.407 237.273 278.974C238.34 280.105 239.228 280.018 240.294 279.322",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M137.035 58.4873C135.993 59.8088 134.382 61.1613 133.494 62.0318C132.072 63.2506 129.855 64.3142 127.9 64.3142",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M127.718 47.8417C130.206 47.1453 132.339 48.1899 134.382 49.4087C133.316 53.065 130.295 53.3262 127.274 53.6744",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M142.468 494.694C142.912 494.956 143.356 495.217 143.712 495.565C144.867 496.522 145.578 497.654 145.133 499.134C144.778 500.179 142.201 501.136 140.957 500.788C139.269 500.44 138.114 499.395 137.759 497.654C137.581 496.871 137.581 496.087 137.492 495.391",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M238.428 232.921C236.118 233.269 233.808 233.356 231.587 233.966",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M154.196 492.867C154.729 493.738 155.263 494.608 155.885 495.392C156.951 496.611 157.306 498.003 156.684 499.396C156.24 500.354 153.93 500.267 152.153 499.396C153.041 498.003 151.797 496.872 151.353 495.74C151.086 494.956 150.287 494.347 150.376 493.389",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M157.573 492.432C158.817 493.215 159.616 494.434 160.327 495.566C161.038 496.61 161.482 498.09 160.683 499.048C159.794 500.092 158.284 500.092 156.951 499.309",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M145.666 498.438C146.466 498.351 146.91 498.874 147.355 499.222C149.132 500.702 150.02 500.702 152.064 499.222",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M133.494 50.5405C131.539 50.2793 129.673 51.1499 127.718 50.9758",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M135.449 26.5142C136.693 24.599 138.736 25.1213 140.602 25.0342",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M232.831 225.782C231.32 227.175 230.609 229.264 228.566 230.135",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M228.388 235.01C226.878 235.793 225.19 236.229 223.502 236.054",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M160.771 168.152C160.15 169.632 160.15 171.199 159.705 172.766",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M226.256 231.268C224.834 232.225 223.146 232.138 221.546 232.486",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M168.502 126.801C169.035 128.02 168.413 129.325 168.68 130.544",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M130.917 41.3135C130.029 42.2711 128.962 42.7934 127.719 43.2287",
    stroke: "#2B4B8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFemale);
export default __webpack_public_path__ + "static/media/body-female.63be1c4ef156bc8da0a18847ad469974.svg";
export { ForwardRef as ReactComponent };